// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const BackButton = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.333 23.333a.664.664 0 0 1-.471-.195L.195 12.471a.666.666 0 0 1 0-.942L10.862.862a.667.667 0 1 1 .943.943L1.61 12l10.195 10.195a.667.667 0 0 1-.472 1.138Z"
			fill="#555"
		/>
	</svg>
);
export default BackButton;
